<div class="d-grid gap-2 col-6 mx-auto">

<button type="button" class="btn btn-primary" (click)="modalOpen = true">
    Launch demo modal
  </button>
</div>
<div class="modal fade" [class.show]="modalOpen" [style.display]="modalOpen ? 'block' : 'none'" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" [attr.aria-hidden]="!modalOpen">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Dropdown in Modal</h5>
          <button type="button" class="btn-close" (click)="modalOpen = false" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          
 <angular-multiselect [data]="itemList" [(ngModel)]="selectedItems" [settings]="settings" (onSelect)="onItemSelect($event)"
 (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)">
 </angular-multiselect>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="modalOpen = false">Close</button>
        </div>
      </div>
    </div>
</div>
<div class="modal-backdrop fade show" *ngIf="modalOpen" (click)="modalOpen = false"></div>
